import { render, staticRenderFns } from "./LogPanel.vue?vue&type=template&id=70f8679f"
import script from "./LogPanel.vue?vue&type=script&lang=js"
export * from "./LogPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports